'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('bcmModule')
    .factory('bcmService', ['$http', '$q', function ($http, $q) {
        var baseUrl = environment.apiUrl + '/Pilot/api/BCM';

        var service = {};

        // Get BCM Lookups
        service.getBCMLookups = function () {
            return $http
                    .get(baseUrl + '/Lookup', { cache: true })
                    .then(function (response) {
                        if (response.error) return $q.reject(response);

                        var container = response.data;

                        // Group Priority Levels By ID
                        container.PriorityLevelsByID = _
                            .chain(container.PriorityLevels)
                            .groupBy('LookupAttributeValueID')
                            .mapValues(function (byID) {
                                return byID[0];
                            })
                            .value();


                        // Group OffSiteExecutions By ID
                        container.OffSiteExecutionsByID = _
                            .chain(container.OffsiteExecutions)
                            .groupBy('LookupAttributeValueID')
                            .mapValues(function (byID) {
                                return byID[0];
                            })
                            .value();

                        // Group OffsiteExecutions By ID
                        container.OperationalWorkaroundsByID = _
                            .chain(container.OperationalWorkarounds)
                            .groupBy('LookupAttributeValueID')
                            .mapValues(function (byID) {
                                return byID[0];
                            })
                            .value();

                        // Group KeyPersonRoles By ID
                        container.KeyPersonRolesByID = _
                            .chain(container.KeyPersonRoles)
                            .groupBy('LookupAttributeValueID')
                            .mapValues(function (byID) {
                                    return byID[0];
                                })
                            .value();

                        return container;
                    });
        };

        return service;
    }]);
